/**
 * sv-router configuration
 * Defines all routes for the application
 */

import { createRouter } from 'sv-router';
import Home from '../routes/Home.svelte';
import Split from '../routes/Split.svelte';
import ExpenseList from '../routes/ExpenseList.svelte';
import Participants from '../routes/Participants.svelte';
import SettlementPage from '../routes/Settlement.svelte';
import Admin from '../routes/Admin.svelte';

export const { p, navigate, isActive, route } = createRouter({
  '/': Home,
  '/splits/:splitId': Split,
  '/splits/:splitId/expenses': ExpenseList,
  '/splits/:splitId/participants': Participants,
  '/splits/:splitId/settlement': SettlementPage,
  '/admin': Admin,
});
